import { render, staticRenderFns } from "./RipaUserDialog.vue?vue&type=template&id=2ddf6b78"
import script from "./RipaUserDialog.vue?vue&type=script&lang=js"
export * from "./RipaUserDialog.vue?vue&type=script&lang=js"
import style0 from "./RipaUserDialog.vue?vue&type=style&index=0&id=2ddf6b78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports